import React from "react";
import PropTypes from "prop-types";

const Textarea = ({
  label,
  value,
  hintText,
  onChange,
  className = "",
  disabled = false,
  destructive = false,
  placeholder = "Enter a description...",
  ...props
}) => {
  return (
    <div className={`textareaContainer ${destructive ? "destructive" : ""}`}>
      <div className="textareaSec">
        {label && <label className="textareaLabel">{label}</label>}
        <textarea
          {...props}
          value={value}
          onChange={onChange}
          disabled={disabled}
          placeholder={placeholder}
          className={`textareaField ${className}`}
        />
      </div>
      {hintText && <div className="textareaHint">{hintText}</div>}
    </div>
  );
};

export default Textarea;

Textarea.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  destructive: PropTypes.bool,
  placeholder: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  hintText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};
